export default "__VITE_ASSET__CIQntJeK__"